import { useReducer } from 'react'
import { createContainer } from 'react-tracked'

import { reducer } from './reducer'
import { State } from './types'

const initialState: State = {}

const useValue = () => useReducer(reducer, initialState)

export const {
  Provider: StoreProvider,
  useTrackedState: useStore,
  useUpdate: useDispatch,
} = createContainer(useValue)
